function SkeletonLine({ className }: { className?: string }) {
    return <div className={`bg-gray-200 rounded animate-pulse ${className ?? ''}`} />;
}

function SkeletonCard() {
    return (
        <div className="bg-white rounded-xl border border-gray-200 p-6 flex flex-col gap-3">
            <SkeletonLine className="h-4 w-1/3" />
            <SkeletonLine className="h-4 w-2/3" />
            <SkeletonLine className="h-4 w-1/2" />
        </div>
    );
}

function SkeletonRows({ count }: { count: number }) {
    return (
        <div className="flex flex-col gap-3">
            {Array.from({ length: count }).map((_, i) => (
                <div
                    key={i}
                    className="flex items-center gap-4 bg-white rounded-xl border border-gray-200 p-4"
                >
                    <SkeletonLine className="h-10 w-10 rounded-lg flex-shrink-0" />
                    <div className="flex-1 flex flex-col gap-2">
                        <SkeletonLine className="h-4 w-1/2" />
                        <SkeletonLine className="h-3 w-1/3" />
                    </div>
                </div>
            ))}
        </div>
    );
}

export { SkeletonLine, SkeletonCard, SkeletonRows };
